export default {"src":"/_next/static/media/mediaLogo1.561929e8.svg","height":64,"width":250,"blurWidth":0,"blurHeight":0};